export const FirebaseConfig = {
	"projectId": "rentcar-drive",
	"appId": "1:529888117660:web:9e2cea540377f543f77e59",
	"databaseURL": "https://rentcar-drive-default-rtdb.firebaseio.com",
	"storageBucket": "rentcar-drive.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyC5op-E-1gTgCrD4CdP2TVVsIHN_fHK3cE",
	"authDomain": "rentcar-drive.firebaseapp.com",
	"messagingSenderId": "529888117660",
	"measurementId": "G-SBZQQ0XBJY"
};